import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Collapse, Stack, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useContext, useEffect, useState } from "react";
import theme from "../../../theme";
import storage from "../../../utils/storage";
import PeopleRowQueries from '../dashboard-queries/PeopleRowQueries';
import AddKeyPeople from '../../atoms/AddKeyPeople';
import { DashboardContext } from '../../../contexts/DashboardContext';

const useStyles = makeStyles(() => ({
    expandIcon: {
        fill: '#666666 !important',
        alignItems: 'center !important',
        justifyContent: 'right',
        cursor: 'pointer',
    },
    addSectionButton: {
        fontFamily: 'Lato',
        fontSize: '1rem',
        fontWeight: '500 !important',
        color: theme.palette.primary.light,
        background: 'transparent',
        textTransform: 'none !important' as any,
        transition: 'ease-in-out 300ms',
        "&:hover": {
            background: 'transparent',
        }
    },
    addButton: {
        minWidth: 150,
        width: 'auto',
        height: 40,
        borderRadius: 24,
        borderColor: theme.colors.neutral['100'],
        background: '#E0F1F1',
        color: theme.palette.primary.main,
        fontSize: '1rem',
        fontWeight: 'bold',
        textTransform: 'none',
        transition: 'ease-in-out 300ms',
    },
    icon: {
        width: 16,
        height: 'auto',
        stroke: theme.palette.primary.light,
    },
    viewsButton: {
        width: 'auto',
        maxWidth: '100%',
        height: 40,
        borderRadius: 24,
        borderColor: theme.colors.neutral['100'],
        background: theme.colors.neutral['100'],
        color: theme.colors.neutral['700'],
        fontSize: '1rem',
        fontWeight: 'bold',
        textTransform: 'none',
        transition: 'ease-in-out 300ms',
        padding: '0 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        "&:hover": {
            background: theme.colors.neutral['200'],
        },
    },
    selectedButton: {
        background: theme.palette.primary.main,
        color: 'white',
        "&:hover": {
            background: theme.colors.primary['800'],
        },
    },
    legendText: {
        fontFamily: 'Inter',
        fontSize: '0.95rem',
        fontWeight: '600',
        color: theme.colors.neutral['600'],
        whiteSpace: 'nowrap',
    },
    legendChip: {
        width: 50,
        height: 10,
    },
    noText: {
        fontFamily: 'Inter',
        fontSize: '1.3rem',
        fontWeight: '600',
        color: theme.colors.neutral['600'],
    },
    otherText: {
        fontFamily: 'Lato',
        fontSize: '1rem',
        fontWeight: 'normal',
        color: theme.colors.neutral['600'],
        textAlign: 'center',
    },
}));

const DashboardKeyPeople: React.FC<{}> = () => {
    const classes = useStyles();
    const { isPublicView } = useContext(DashboardContext);
    const [isExpanded, setExpanded] = useState<boolean>(true);

    useEffect(() => {
        if (storage.getItem('config.dashboard-key-people.expanded'))
            setExpanded(true);
    }, []);

    return (<>
        <Collapse in={isExpanded} collapsedSize={40}>
            <Stack direction="column" spacing={3} alignItems="stretch" width="100%" height="100%" minHeight={300} pb={5}>
                <Stack direction="row" spacing={2} alignItems="flex-start" marginLeft={1}>
                    <Typography fontFamily="Inter" fontWeight="bold" fontSize="1.3rem" color="#666666">
                        {'Key People'}
                    </Typography>
                    <ExpandMoreIcon
                        className={classes.expandIcon}
                        sx={isExpanded ? { transform: 'rotate(180deg) !important' } : {}}
                        onClick={(e)=> {
                            e.stopPropagation();
                            e.preventDefault();
                            setExpanded((prev) => !prev);
                            storage.setItem('config.dashboard-key-people.expanded', !isExpanded);
                        }} />
                    {!isPublicView && isExpanded && <AddKeyPeople />}
                </Stack>
                <PeopleRowQueries />
            </Stack>
        </Collapse>
    </>);
}

export default DashboardKeyPeople;